import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Mentions() {
  return (
    <LegalShell title="Mentions légales" lastUpdated="6 février 2026" testId="page-mentions">
      <h2>Éditeur du site</h2>
      <ul>
        <li><strong>Nom / Raison sociale</strong> : LHASSANI Jamira</li>
        <li><strong>Statut juridique</strong> : Entrepreneur individuel (auto-entrepreneur)</li>
        <li><strong>Adresse du siège</strong> : 6 avenue de la Légion Tchèque, 64100 Bayonne</li>
        <li><strong>Email de contact</strong> : contact.servicedecomdu64@gmail.com</li>
        <li><strong>SIRET</strong> : 422 541 649 00022</li>
        <li><strong>Code NAF / APE</strong> : 7022Z (Conseil pour les affaires et autres conseils de gestion)</li>
        <li><strong>TVA intracommunautaire</strong> : Non applicable, art. 293 B du CGI (franchise en base)</li>
        <li><strong>Directeur de la publication</strong> : Jamira LHASSANI</li>
      </ul>

      <h2>Hébergement</h2>
      <ul>
        <li><strong>Hébergeur principal</strong> : Emergent Labs</li>
        <li><strong>Stockage des données</strong> : MongoDB / Emergent Object Storage — Union Européenne</li>
        <li><strong>Distribution / CDN</strong> : Géré par la plateforme Emergent</li>
      </ul>

      <h2>Propriété intellectuelle</h2>
      <p>L'ensemble du contenu présent sur Student Hub (textes, illustrations, logos, modèles de lettres, code) est protégé par le droit d'auteur. Toute reproduction, adaptation ou diffusion sans autorisation préalable et écrite est interdite, sauf pour les modèles téléchargeables qui peuvent être utilisés à titre personnel.</p>
      <p>Les marques tierces affichées (CAF, CROUS, Ameli, SNCF, etc.) restent la propriété de leurs détenteurs respectifs et sont citées à des fins informatives uniquement.</p>

      <h2>Crédits</h2>
      <ul>
        <li>Logos officiels : Clearbit Logo API</li>
        <li>Photos d'ambiance : Unsplash (licence Unsplash)</li>
        <li>Icônes : Lucide</li>
      </ul>

      <h2>Signaler un contenu</h2>
      <p>Pour signaler un contenu illicite ou contraire aux CGU, contacter : <strong>contact.servicedecomdu64@gmail.com</strong>. Réponse sous 72 heures.</p>

      <h2>Médiation de la consommation</h2>
      <p>
        Conformément à l'article L.612-1 du code de la consommation, en cas de litige non résolu à l'amiable
        dans un délai de 30 jours, tu peux saisir gratuitement notre médiateur :
      </p>
      <ul>
        <li><strong>Médiateur</strong> : Centre de la Médiation de la Consommation de Conciliateurs de justice (CM2C)</li>
        <li><strong>Adresse</strong> : 49 rue de Ponthieu, 75008 Paris</li>
        <li><strong>Téléphone</strong> : 01 89 47 00 14</li>
        <li><strong>Site</strong> : <a href="https://www.cm2c.net" target="_blank" rel="noreferrer">www.cm2c.net</a></li>
        <li><strong>Numéro d'adhérent</strong> : W751237320 (validité jusqu'au 10/05/2029)</li>
      </ul>
      <p>
        Tu peux également recourir à la plateforme européenne de Règlement en Ligne des Litiges (RLL) :
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.
      </p>
    </LegalShell>
  );
}
